<template>
  <v-menu offset-y left>
    <template v-slot:activator="{ on, attrs }">
      <v-btn icon small v-bind="attrs" v-on="on" :aria-label="$t('common.language')">
        <v-icon>{{ icons.mdiTranslate }}</v-icon>
      </v-btn>
    </template>
    <v-list dense>
      <v-list-item
        v-for="locale in availableLocales"
        :key="locale.code"
        :input-value="locale.code === $i18n.locale"
        @click="pick(locale.code)"
      >
        <v-list-item-title>
          <span v-if="locale.flag" class="me-2">{{ locale.flag }}</span>{{ locale.name }}
        </v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import { mdiTranslate } from '@mdi/js'
import { availableLocales, setLocale } from '@/plugins/i18n'

export default {
  data() {
    return {
      availableLocales,
      icons: { mdiTranslate },
    }
  },
  methods: {
    pick(code) {
      setLocale(code)
    },
  },
}
</script>
